import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useRuntimeStore = defineStore("runtime", () => {
  let message = ref(false);
  let viewCount = ref(0);

  const noticeSuccess = (messageText) => {
    message.value = { type: "success", message: messageText };
  };

  const noticeFailure = (messageText) => {
    message.value = { type: "error", message: messageText };
  };

  const clearMessage = () => {
    message.value = false;
  };

  const hasMessage = computed(() => {
    return message.value !== false;
  });

  const incrementViewCount = () => {
    viewCount.value = viewCount.value + 1;
    if (viewCount.value > 1) {
      viewCount.value = 0;
      clearMessage();
    }
  };

  return {
    noticeFailure,
    noticeSuccess,
    clearMessage,
    hasMessage,
    message,
    incrementViewCount,
  };
});
